import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import HomeScrollY from "@components/layout/HomeScrollY";

function HomeContainer({ blok }) {
  return (
    <HomeScrollY {...storyblokEditable(blok)} key={blok._uid}>
      <>
        {blok.header?.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
        {blok.body?.map((nestedBlok) => (
          <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </>
    </HomeScrollY>
  );
}

export default HomeContainer;
